// extracted by mini-css-extract-plugin
export default {"header":"Appeals_header__6lZli","appeals":"Appeals_appeals__mvx5J","line":"Appeals_line__PK4V6","empty":"Appeals_empty__B3Swa"};